module.exports = __webpack_public_path__ + "images/emoji/signal_strength.cc2d966d317e2f158d9f.png";